import React, { Component } from "react";
import styled from "styled-components";
import { Icon, Popover, IconButton } from "@material-ui/core";

const MenuContainer = styled.div`
    background: #fff;

    .icon-button-menu-item {
        padding: 20px 30px;
        cursor: pointer;

        &:hover {
            background: #eee;
        }
    }
`;

export default class IconButtonMenu extends Component {
    constructor() {
        super();

        this.state = {
            anchorEl: null
        };
    }

    toggleMenu = event => {
        this.state.anchorEl
            ? this.setState({ anchorEl: null })
            : this.setState({ anchorEl: event.currentTarget });
    };

    render = () => {
        const {
            customLayout = false,
            icon = "more_vert",
            anchorOrigin = {
                vertical: "top",
                horizontal: "left"
            },
            transformOrigin = {
                vertical: "top",
                horizontal: "left"
            },
        } = this.props;
        const {
            anchorEl,
        } = this.state;

        let menuItems = React.Children.map(this.props.children, child => {
            let {
                className = "",
                onClick,
            } = child.props;

            // Only modify the child if it has an onClick handler
            if (!onClick) {
                return child;
            }

            // If we aren't flagged as going custom,
            //   add a class to enable standard menu layout
            if (!customLayout) {
                className = className + " icon-button-menu-item";
            }

            return React.cloneElement(child, {
                className,
                onClick: event => {
                    onClick(event);

                    // Close the popover
                    this.setState({ anchorEl: null });
                },
            });
        });

        return (
            <>
                <IconButton
                    aria-haspopup="true"
                    onClick={this.toggleMenu}
                    aria-label="Change palette"
                >
                    <Icon>{icon}</Icon>
                </IconButton>

                <Popover
                    disableEnforceFocus
                    open={!!anchorEl}
                    anchorEl={anchorEl}
                    anchorOrigin={anchorOrigin}
                    transformOrigin={transformOrigin}
                    onClose={this.toggleMenu}
                >
                    <MenuContainer>
                        {menuItems}
                    </MenuContainer>
                </Popover>
            </>
        );
    };
}
